import { z } from "zod";

export type Form = z.infer<typeof FormSchema>;
export const FormSchema = z.object({
  id: z.string(),
  type: z.string(),
  digit: z.number(),
  value: z.any(),
});
